var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useRef, useState, useCallback, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { risonDecodeOrIgnore } from "../../utils";
import { useLocation, useSearchParams } from 'react-router-dom';
import { Icon } from "../../UI";
import { I18NLink, t } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";


import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";
import { encodeSearch } from "../actions/libraryActions";
import {
  getCurrentSortOption,
  getPropertySortType,


  filterTemplates,
  getSortOptions } from "../helpers/sortComponets";






const getOptionUrl = (option, path, query) => {
  const currentQuery = risonDecodeOrIgnore(decodeURIComponent(query || '()'));
  const type = getPropertySortType(option);
  return `${path}${encodeSearch(_objectSpread(_objectSpread({},
  currentQuery), {}, { order: type === 'string' ? 'asc' : 'desc', sort: option.value, from: 0 }),
  true
  )}`;
};

const mapStateToProps = (state, ownProps) => {
  let { templates } = state;

  if (ownProps.selectedTemplates && ownProps.selectedTemplates.count()) {
    templates = filterTemplates(state.templates, ownProps.selectedTemplates);
  }

  return {
    templates,
    locale: state.locale
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ merge: actions.merge }, wrapDispatch(dispatch, 'library'));

const connector = connect(mapStateToProps, mapDispatchToProps);



// eslint-disable-next-line max-statements
const SortDropdownComponent = ({ templates, locale }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const currentQuery = risonDecodeOrIgnore(
    decodeURIComponent(searchParams.get('q') || '()')
  );
  const path = location.pathname.replace(new RegExp(`^/?${locale}/|^/?${locale}$`), '');
  const sortButtonLink = `${path}${encodeSearch(_objectSpread(_objectSpread({},
  currentQuery), {}, { order: currentQuery.order === 'asc' ? 'desc' : 'asc', from: 0 }),
  true
  )}`;

  useEffect(() => {
    setDropdownOpen(false);
  }, [currentQuery.sort]);

  useOnClickOutsideElement(
    menuRef,
    useCallback(() => {
      setDropdownOpen(false);
    }, [])
  );

  const sortOptions = getSortOptions(currentQuery, templates);

  return /*#__PURE__*/(
    _jsx("div", { className: "sort-buttons" }, void 0, /*#__PURE__*/
    React.createElement("div", { className: "sort-dropdown", ref: menuRef }, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: `dropdown-button ${dropdownOpen ? 'expanded' : ''}`,
      onClick: () => setDropdownOpen(!dropdownOpen) }, void 0, /*#__PURE__*/

    _jsx("span", {}, void 0, getCurrentSortOption(sortOptions, currentQuery.sort)), /*#__PURE__*/
    _jsx(Icon, { icon: dropdownOpen ? 'caret-up' : 'caret-down' })
    ), /*#__PURE__*/

    _jsx("ul", { className: `dropdown-menu ${dropdownOpen ? 'expanded' : ''}` }, void 0,
    sortOptions.map((option) => {
      const url = getOptionUrl(option, path, searchParams.get('q'));
      return /*#__PURE__*/(
        _jsx("li", {}, option.value, /*#__PURE__*/
        _jsx(I18NLink, { to: url, href: url }, void 0,
        option.label
        )
        ));

    })
    )
    ), /*#__PURE__*/

    _jsx(I18NLink, {
      to: sortButtonLink,
      href: sortButtonLink,
      disable: currentQuery.sort === '_score' ? 'true' : undefined }, void 0, /*#__PURE__*/

    _jsx("button", {
      type: "button",
      disabled: currentQuery.sort === '_score' ? true : undefined,
      onClick: () => {},
      className: "sorting-toggle" }, void 0, /*#__PURE__*/

    _jsx("span", { style: { display: 'none' } }, void 0,
    currentQuery.order === 'asc' ?
    t('System', 'Sort descending', undefined, false) :
    t('System', 'Sort ascending', undefined, false)
    ), /*#__PURE__*/
    _jsx(Icon, {
      icon:
      currentQuery.order === 'asc' && currentQuery.sort !== '_score' ?
      'arrow-up' :
      'arrow-down' }

    )
    )
    )
    ));

};

const container = connector(SortDropdownComponent);
export { container as SortDropdown };